/**
 * Reusable error display component
 * Shows user-friendly error messages with retry option
 */

interface ErrorDisplayProps {
  error: Error | string
  onRetry?: () => void
  title?: string
}

const ErrorDisplay = ({ error, onRetry, title = 'Something went wrong' }: ErrorDisplayProps) => {
  const errorMessage = typeof error === 'string' ? error : error?.message ?? 'An unexpected error occurred'

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '40px 20px',
      textAlign: 'center',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    }}>
      {/* Error Icon */}
      <div style={{
        width: '64px',
        height: '64px',
        margin: '0 auto 20px',
        backgroundColor: '#fee2e2',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#dc2626"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      {/* Error Title */}
      <h3 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
      }}>
        {title}
      </h3>

      {/* Error Message */}
      <p style={{
        fontSize: '14px',
        color: '#64748b',
        marginBottom: onRetry ? '24px' : '0',
        maxWidth: '500px',
        margin: '0 auto',
        lineHeight: '1.5',
      }}>
        {errorMessage}
      </p>

      {/* Retry Button */}
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            marginTop: '24px',
            padding: '10px 24px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#3b82f6'
          }}
        >
          Try Again
        </button>
      )}
    </div>
  )
}

export default ErrorDisplay
